/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, {
    CATEGORY_AUTHORIZATION,
    ERROR_MESSAGE_TOKEN_INVALID,
    ERROR_MESSAGE_UNEXPECTED,
    HTTP_STATUS_BAD_REQUEST,
    HTTP_STATUS_FORBIDDEN,
    HTTP_STATUS_NO_CONTENT,
    HTTP_STATUS_OK,
    HTTP_STATUS_UNAUTHORIZED,
} from "./core/BaseService";

// ログイン制限時のエラーの判定で利用
const LOGIN_ERROR_MESSAGE = "ログイン人数制限をオーバーしています。<br />しばらく待ってからログインしてください。";
export const ERROR_ACCESS_LIMIT = "ERROR_ACCESS_LIMIT";

// パスワードポリシーに違反しているかの判定で利用
const ERROR_MESSAGE_PASSWORD_POLICY = "パスワードポリシーに反しています。<br />パスワードを更新して下さい。";
export const ERROR_PASSWORD_POLICY = "ERROR_PASSWORD_POLICY";

// パスワードの有効期限が切れているかの判定で利用
export const ERROR_MESSAGE_PASSWORD_EXPIRED = "パスワードの有効期限が切れています。<br />パスワードを更新してください。";
export const ERROR_PASSWORD_EXPIRED = "ERROR_PASSWORD_EXPIRED";

export interface LoginPayload {
    loginId: string;
    password: string;
    companyCode?: string;
}

export interface LoginResponse {
    accessToken: string;
    refreshToken: string;
    authKey?: string;
}

class LoginService extends BaseService {
    constructor() {
        super(CATEGORY_AUTHORIZATION, "login", false);
    }

    public async login(payload: LoginPayload, resolved: (json: LoginResponse) => void, rejected: (error: any) => void) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as LoginResponse;
                resolved(response);
            },
            rejected
        );
    }

    protected async errorHandler(response: Response): Promise<Response> {
        const { status } = response;
        if (response.ok && (status === HTTP_STATUS_OK || status === HTTP_STATUS_NO_CONTENT)) {
            return response;
        }

        const json = await response.json();
        switch (status) {
            case HTTP_STATUS_UNAUTHORIZED:
                if (json.authKey) {
                    switch (json.message) {
                        case ERROR_MESSAGE_PASSWORD_POLICY:
                            throw Error(`${ERROR_PASSWORD_POLICY}:${json.authKey}`);
                        case ERROR_MESSAGE_PASSWORD_EXPIRED:
                            throw Error(`${ERROR_PASSWORD_EXPIRED}:${json.authKey}`);
                        default:
                            throw Error(ERROR_MESSAGE_TOKEN_INVALID);
                    }
                } else {
                    throw Error(ERROR_MESSAGE_TOKEN_INVALID);
                }

            case HTTP_STATUS_FORBIDDEN:
                throw Error(ERROR_MESSAGE_TOKEN_INVALID);

            case HTTP_STATUS_BAD_REQUEST:
                json.errors.forEach((responseObj: any) => {
                    const { detail } = responseObj;
                    if (LOGIN_ERROR_MESSAGE === detail) {
                        throw Error(ERROR_ACCESS_LIMIT);
                    }
                });

                const message = (json.errors || []).map((e: any) => `${e.item}: ${e.detail}`).join("\n");
                throw Error(message);

            default:
                throw Error(ERROR_MESSAGE_UNEXPECTED);
        }
    }
}

export default LoginService;
